<template>
  <div
    class="tw-relative tw-flex tw-items-start"
    :class="[{ 'animation-pulse': isError }, attrs.class]"
  >
    <div class="tw-flex tw-h-5 tw-items-center">
      <input
        :id="id"
        type="checkbox"
        :checked="checkedValue"
        @change="handleChange"
        :class="{ 'tw-border-error-500': isError }"
        :test_id="attrs.test_id"
        :disabled="isDisabled"
        :autocomplete="attrs.autocomplete"
        :tabindex="attrs.tabindex"
      />
    </div>
    <FormLabel
      class="tw-ml-2"
      :class="{ 'tw-text-error-500': isError }"
      :id="id"
      is-checkbox-label
      :is-required="isRequired"
      :tooltip="tooltip"
    >
      <slot />
    </FormLabel>
  </div>
</template>

<script setup>
import FormLabel from './FormLabel.vue'
import { getUniqueId } from '@/shared/utils/uniqueId.js'
import { computed, useAttrs } from 'vue'

const emit = defineEmits([
  'update:unchecked',
  'update:checked',
  'update:modelValue',
  'input',
])

const props = defineProps({
  modelValue: {
    type: [Array, Boolean],
    default: false,
  },
  value: {
    type: [String, Number],
    default: '',
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: '',
  },
  isError: {
    type: Boolean,
    default: false,
  },
})

const attrs = useAttrs()

const id = `growthmentor-checkbox-${getUniqueId()}`

const checkedValue = computed(() => {
  return Array.isArray(props.modelValue)
    ? props.modelValue.includes(props.value)
    : props.modelValue
})

const handleChange = () => {
  if (Array.isArray(props.modelValue)) {
    const checkboxArray = [...props.modelValue]
    if (checkboxArray.includes(props.value)) {
      checkboxArray.splice(checkboxArray.indexOf(props.value), 1)
      emit('update:unchecked', props.value)
    } else {
      checkboxArray.push(props.value)
      emit('update:checked', props.value)
    }
    emit('update:modelValue', checkboxArray)
    // 'input' emit is backward compatibility with Vue 2 v-model
    emit('input', checkboxArray)
  } else {
    const newCheckedValue = !props.modelValue
    if (newCheckedValue) {
      emit('update:checked', props.value)
    } else {
      emit('update:unchecked', props.value)
    }
    emit('update:modelValue', newCheckedValue)
    // 'input' emit is backward compatibility with Vue 2 v-model
    emit('input', newCheckedValue)
  }
}
</script>

<script>
export default {
  inheritAttrs: false,
}
</script>
